/*
 * Shopify Combined Listings compatibility layer for Stiletto 1.7.
 *
 * PDP: switches child products through the Section Rendering API.
 * Cards: loads the selected child lazily through the product Ajax endpoint.
 */
(function () {
  'use strict';

  if (window.BDPCombinedListings) return;

  var selectors = {
    productSection: '[data-combined-listings-product-section]',
    productPicker: '[data-combined-listings-picker]',
    productOption: '[data-combined-listing-value]',
    card: '[data-combined-listings-card]',
    cardOption: '[data-combined-listings-card-option]',
    cardTitle: '[data-combined-listings-card-title]',
    cardPrice: '[data-combined-listings-card-price]',
    productLink: '[data-combined-listings-product-link]'
  };

  var productCache = new Map();
  var cardRequests = new WeakMap();
  var productRequest = null;

  function debugEnabled() {
    try {
      return new URLSearchParams(window.location.search).get('combined_listings_debug') === 'true' ||
        window.localStorage.getItem('combinedListingsDebug') === 'true' ||
        Boolean(window.Shopify && window.Shopify.designMode);
    } catch (error) {
      return Boolean(window.Shopify && window.Shopify.designMode);
    }
  }

  function debug() {
    if (!debugEnabled()) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[BDP Combined Listings]');
    window.console.log.apply(window.console, args);
  }

  function normalizeUrl(url) {
    return new URL(url || window.location.href, window.location.origin);
  }

  function normalizePath(url) {
    try {
      return normalizeUrl(url).pathname.replace(/\/$/, '');
    } catch (error) {
      return '';
    }
  }

  function unique(values) {
    return Array.from(new Set(values.filter(Boolean).map(String)));
  }

  function preservePreviewParameters(url) {
    var current = normalizeUrl(window.location.href);
    ['preview_theme_id', 'preview_token', '_fd', 'pb'].forEach(function (name) {
      if (!url.searchParams.has(name) && current.searchParams.has(name)) {
        url.searchParams.set(name, current.searchParams.get(name));
      }
    });
    return url;
  }

  function addOptionValues(url, optionValueIds) {
    var target = preservePreviewParameters(normalizeUrl(url));

    if (optionValueIds.length) {
      target.searchParams.set('option_values', optionValueIds.join(','));
    }

    return target;
  }

  function optionFromEventTarget(target) {
    if (!(target instanceof Element)) return null;

    if (target.matches('select')) {
      var selectedOption = target.options[target.selectedIndex];
      return selectedOption && selectedOption.matches(selectors.productOption)
        ? selectedOption
        : null;
    }

    var directOption = target.closest(selectors.productOption);
    if (directOption) return directOption;

    var label = target.closest('label[for]');
    if (!label) return null;

    var input = document.getElementById(label.htmlFor);
    return input && input.matches(selectors.productOption) ? input : null;
  }

  function selectedOptionValueIds(picker, changedOption) {
    var optionGroupSelector = '.product__option[data-product-option]';
    var changedGroup = changedOption.closest(optionGroupSelector);
    var values = [];

    picker.querySelectorAll(optionGroupSelector).forEach(function (group) {
      if (group === changedGroup) {
        values.push(changedOption.dataset.optionValueId);
        return;
      }

      var selected = group.querySelector('select option:checked[data-option-value-id]') ||
        group.querySelector('input:checked[data-option-value-id]') ||
        group.querySelector('button.selected[data-option-value-id]');

      if (selected) values.push(selected.dataset.optionValueId);
    });

    if (!values.length) values.push(changedOption.dataset.optionValueId);
    return unique(values);
  }

  function shouldSwitchProduct(option) {
    if (!option || !option.dataset.productUrl) return false;

    var section = option.closest(selectors.productSection);
    var currentUrl = section ? section.dataset.productUrl : window.location.pathname;
    return normalizePath(option.dataset.productUrl) !== normalizePath(currentUrl);
  }

  function findRenderedProductSection(doc, sectionId) {
    var sections = Array.prototype.slice.call(doc.querySelectorAll(selectors.productSection));
    return sections.find(function (section) {
      return section.dataset.sectionId === sectionId;
    }) || sections[0] || null;
  }

  function themeSectionInstance(container) {
    var sectionApi = window.Shopify && window.Shopify.theme && window.Shopify.theme.sections;
    if (!sectionApi || !Array.isArray(sectionApi.instances)) return null;

    return sectionApi.instances.find(function (instance) {
      return instance.container === container;
    }) || null;
  }

  function unloadThemeSection(container) {
    var sectionApi = window.Shopify && window.Shopify.theme && window.Shopify.theme.sections;
    if (!sectionApi || !Array.isArray(sectionApi.instances)) return;

    var instance = themeSectionInstance(container);
    if (!instance) return;

    try {
      if (typeof instance.onUnload === 'function') instance.onUnload();
    } catch (error) {
      // Stiletto 1.7 can try to destroy optional widgets that were never
      // initialized. That must not prevent the product section replacement.
      debug('Theme section cleanup was incomplete', error);
    } finally {
      var index = sectionApi.instances.indexOf(instance);
      if (index !== -1) sectionApi.instances.splice(index, 1);
    }
  }

  function loadThemeSection(container) {
    var sectionApi = window.Shopify && window.Shopify.theme && window.Shopify.theme.sections;
    if (!sectionApi || !sectionApi.registered || !Array.isArray(sectionApi.instances)) return;
    if (themeSectionInstance(container)) return;

    var type = container.dataset.sectionType;
    var TypedSection = sectionApi.registered[type];
    if (!TypedSection) return;

    sectionApi.instances.push(new TypedSection(container));
  }

  function dispatchSectionEvent(name, container, sectionId) {
    container.dispatchEvent(new CustomEvent(name, {
      bubbles: true,
      detail: { sectionId: sectionId }
    }));
  }

  function initializeWishlistHero(section) {
    var slot = section.querySelector('#wishlist-hero-product-page-button');
    if (!slot || slot.querySelector('#wishlisthero-product-page-button-container')) return;

    function initialize() {
      var sdk = window.WishListHero_SDK;
      if (!sdk || typeof sdk.InitializeAddToWishListButton !== 'function') return false;

      var wishlistHash = typeof sdk.GetWishListHash === 'function'
        ? sdk.GetWishListHash(true)
        : '';

      Promise.resolve(wishlistHash).then(function (hash) {
        if (!slot.isConnected || slot.childElementCount) return;

        var buttonClass = slot.dataset.wishlistButtonClass || 'combined-listings-wishlist-target';
        var mountClass = buttonClass + '-mount';
        var mount = document.createElement('div');
        mount.id = 'wishlisthero-product-page-button-container';
        mount.className = 'wishlisthero-product-page-button-container ' + mountClass;
        slot.appendChild(mount);

        var result = sdk.InitializeAddToWishListButton({
          ProductId: Number(slot.dataset.wishlistProductId),
          ProductVariantId: Number(slot.dataset.wishlistVariantId),
          ProductTitle: slot.dataset.wishlistProductTitle || '',
          ProductPrice: Number(slot.dataset.wishlistProductPrice),
          ProductLink: slot.dataset.wishlistProductLink || '',
          ProductImage: slot.dataset.wishlistProductImage || '',
          WishlistHash: typeof hash === 'string' ? hash : '',
          ButtonClassElement: mountClass,
          ButtonMode: window.WishListHero_setting && window.WishListHero_setting.DisplayButtonAs
            ? window.WishListHero_setting.DisplayButtonAs
            : ''
        });

        if (result && result.ok === false) {
          mount.remove();
          debug('Wishlist Hero initialization was rejected', result);
        }
      }).catch(function (error) {
        window.console.error('[BDP Combined Listings] Wishlist update failed.', error);
      });

      return true;
    }

    if (initialize()) return;

    document.addEventListener('wishlist-hero-wishlist-sdk-ready', function () {
      initialize();
    }, { once: true });

    window.setTimeout(function () {
      if (!slot.childElementCount) initialize();
    }, 500);
  }

  function unmountProductSection(section) {
    var eventTarget = section.closest('.shopify-section') || section;

    if (window.Shopify && window.Shopify.designMode) {
      dispatchSectionEvent('shopify:section:unload', eventTarget, section.dataset.sectionId);
    } else {
      unloadThemeSection(section);
      dispatchSectionEvent('shopify:section:unload', eventTarget, section.dataset.sectionId);
    }
  }

  function mountProductSection(section) {
    var eventTarget = section.closest('.shopify-section') || section;

    if (window.Shopify && window.Shopify.designMode) {
      dispatchSectionEvent('shopify:section:load', eventTarget, section.dataset.sectionId);
    } else {
      loadThemeSection(section);
      dispatchSectionEvent('shopify:section:load', eventTarget, section.dataset.sectionId);
    }

    try {
      if (window.Shopify && window.Shopify.PaymentButton) {
        window.Shopify.PaymentButton.init();
      }
    } catch (error) {
      debug('Payment button refresh failed', error);
    }

    document.dispatchEvent(new CustomEvent('products:update', {
      detail: { container: section }
    }));
    document.dispatchEvent(new CustomEvent('currency:update'));
    initializeWishlistHero(section);
  }

  async function requestProductSection(url, sectionId, signal) {
    var requestUrl = new URL(url.toString());
    requestUrl.searchParams.set('section_id', sectionId);

    var response = await fetch(requestUrl.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: signal
    });

    if (!response.ok) {
      throw new Error('Product section request failed (' + response.status + ')');
    }

    var responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
    return findRenderedProductSection(responseDocument, sectionId);
  }

  async function requestProductDocument(url, signal) {
    var response = await fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: signal
    });

    if (!response.ok) {
      throw new Error('Product document request failed (' + response.status + ')');
    }

    var responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
    return findRenderedProductSection(responseDocument, '');
  }

  async function swapProductSection(option) {
    var section = option.closest(selectors.productSection);
    var picker = option.closest(selectors.productPicker);
    var productUrl = option.dataset.productUrl;

    if (!section || !picker || !productUrl) return;

    var optionValueIds = selectedOptionValueIds(picker, option);
    var sectionId = section.dataset.sectionId;
    var historyUrl = addOptionValues(productUrl, optionValueIds);

    productRequest && productRequest.abort();
    productRequest = new AbortController();

    section.classList.add('is-combined-listings-loading');
    section.setAttribute('aria-busy', 'true');
    debug('PDP request', historyUrl.toString(), optionValueIds);

    try {
      var nextSection = await requestProductSection(historyUrl, sectionId, productRequest.signal);

      if (!nextSection) {
        debug('Section ID not found on sibling template; using full document fallback');
        nextSection = await requestProductDocument(historyUrl, productRequest.signal);
      }

      if (!nextSection) throw new Error('Rendered product section was not found');

      var currentContainer = section.closest('.shopify-section') || section;
      var nextContainer = nextSection.closest('.shopify-section') || nextSection;

      unmountProductSection(section);
      currentContainer.replaceWith(nextContainer);

      var mountedSection = nextContainer.matches(selectors.productSection)
        ? nextContainer
        : nextContainer.querySelector(selectors.productSection);

      if (!mountedSection) throw new Error('Mounted product section was not found');

      mountProductSection(mountedSection);

      var selectedVariantId = mountedSection.dataset.currentProductId;
      if (selectedVariantId) historyUrl.searchParams.set('variant', selectedVariantId);
      historyUrl.searchParams.delete('section_id');

      window.history.replaceState({
        path: historyUrl.pathname + historyUrl.search,
        combinedListing: true
      }, '', historyUrl.pathname + historyUrl.search + historyUrl.hash);

      document.dispatchEvent(new CustomEvent('combined-listings:product-changed', {
        detail: {
          productUrl: mountedSection.dataset.productUrl,
          sectionId: mountedSection.dataset.sectionId,
          variantId: selectedVariantId,
          optionValueIds: optionValueIds
        }
      }));
    } catch (error) {
      if (error.name !== 'AbortError') {
        window.console.error('[BDP Combined Listings] Product update failed.', error);
        section.classList.remove('is-combined-listings-loading');
        section.removeAttribute('aria-busy');
      }
    }
  }

  function productJsonUrl(productUrl) {
    var url = normalizeUrl(productUrl);
    url.pathname = url.pathname.replace(/\/$/, '').replace(/\.js$/, '') + '.js';
    url.search = '';
    return preservePreviewParameters(url).toString();
  }

  function fetchProduct(productUrl) {
    var url = productJsonUrl(productUrl);

    if (!productCache.has(url)) {
      productCache.set(url, fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Product request failed (' + response.status + ')');
        return response.json();
      }).catch(function (error) {
        productCache.delete(url);
        throw error;
      }));
    }

    return productCache.get(url);
  }

  function selectedVariant(product, variantId) {
    var variants = product.variants || [];
    return variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    }) || variants.find(function (variant) {
      return variant.available;
    }) || variants[0] || null;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;

    if (isNaN(number) || number == null) return '0';

    var parts = (number / 100).toFixed(precision).split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  function formatMoney(cents) {
    var format = window.theme && window.theme.moneyFormat
      ? window.theme.moneyFormat
      : '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    var value = '';

    if (!match) return formatWithDelimiters(cents, 2);

    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount':
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return format.replace(placeholderRegex, value);
  }

  function imageSource(image) {
    if (!image) return '';
    return typeof image === 'string' ? image : image.src || image.url || '';
  }

  function imageUrlWithWidth(source, width) {
    if (!source) return '';

    try {
      var url = normalizeUrl(source);
      url.searchParams.set('width', width);
      return url.toString();
    } catch (error) {
      return source;
    }
  }

  function updateImage(image, source, alt) {
    if (!image || !source) return;

    image.src = imageUrlWithWidth(source, 720);
    image.srcset = [180, 360, 540, 720, 900]
      .map(function (width) {
        return imageUrlWithWidth(source, width) + ' ' + width + 'w';
      })
      .join(', ');
    image.alt = alt || '';
    image.removeAttribute('hidden');
  }

  function updateCardMedia(card, product, variant) {
    var images = Array.prototype.slice.call(card.querySelectorAll('.product-item__image img'));
    var mainSource = imageSource(variant && variant.featured_image) ||
      imageSource(product.featured_image) ||
      imageSource(product.images && product.images[0]);
    var hoverSource = (product.images || []).map(imageSource).find(function (source) {
      return source && source !== mainSource;
    });

    updateImage(images[0], mainSource, product.title);

    if (images[1] && hoverSource) {
      updateImage(images[1], hoverSource, product.title);
    } else if (images[1]) {
      images[1].setAttribute('hidden', '');
    }
  }

  function updateCardPrice(card, variant, option) {
    var priceContainer = card.querySelector(selectors.cardPrice);
    if (!priceContainer) return;

    var price = variant ? variant.price : Number(option.dataset.price || 0);
    var compareAtPrice = variant
      ? variant.compare_at_price
      : Number(option.dataset.compareAtPrice || 0);

    if (compareAtPrice && compareAtPrice > price) {
      priceContainer.innerHTML =
        '<s class="t-subdued">' + formatMoney(compareAtPrice) + '</s> ' +
        '<span class="sale" data-price>' + formatMoney(price) + '</span>';
    } else {
      priceContainer.innerHTML =
        '<span class="product-item__price">' + formatMoney(price) + '</span>';
    }
  }

  function updateCardLinks(card, productUrl, title) {
    card.querySelectorAll(selectors.productLink).forEach(function (link) {
      link.href = productUrl;
      link.setAttribute('aria-label', title);
    });

    card.querySelectorAll('.show-product-quickview').forEach(function (button) {
      button.setAttribute('href', productUrl);
    });
  }

  function updateCardControls(card, product, variant) {
    card.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.value = variant ? variant.id : '';
    });

    card.querySelectorAll('button[type="submit"]').forEach(function (button) {
      button.disabled = !variant || !variant.available;
      button.setAttribute('aria-disabled', String(!variant || !variant.available));
    });

    card.querySelectorAll('.jdgm-widget[data-id]').forEach(function (widget) {
      widget.dataset.id = product.id;
    });
  }

  function updateCardPicker(card, activeOption) {
    card.querySelectorAll(selectors.cardOption).forEach(function (option) {
      var active = option === activeOption;
      option.classList.toggle('is-active', active);
      option.setAttribute('aria-pressed', String(active));
    });
  }

  function updateCard(card, option, product, variant, productUrl) {
    var title = card.querySelector(selectors.cardTitle);
    if (title) title.textContent = product.title;

    card.dataset.productId = product.id;
    card.dataset.productHandle = product.handle;
    card.dataset.productUrl = product.url;
    card.classList.toggle('product-item--sold-out', !variant || !variant.available);

    updateCardLinks(card, productUrl, product.title);
    updateCardMedia(card, product, variant);
    updateCardPrice(card, variant, option);
    updateCardControls(card, product, variant);
    updateCardPicker(card, option);

    document.dispatchEvent(new CustomEvent('currency:update'));
    document.dispatchEvent(new CustomEvent('combined-listings:card-changed', {
      detail: { card: card, product: product, variant: variant }
    }));
  }

  async function selectCardOption(option) {
    if (option.disabled || option.dataset.available === 'false') return;
    if (option.getAttribute('aria-pressed') === 'true') return;

    var card = option.closest(selectors.card);
    if (!card || !option.dataset.productUrl) return;

    var previousRequest = cardRequests.get(card);
    previousRequest && previousRequest.abort();

    var controller = new AbortController();
    cardRequests.set(card, controller);
    card.classList.add('is-combined-listings-loading');
    card.setAttribute('aria-busy', 'true');

    try {
      var product = await fetchProduct(option.dataset.productUrl);
      if (controller.signal.aborted) return;

      var variant = selectedVariant(product, option.dataset.variantId);
      var productUrl = addOptionValues(option.dataset.productUrl, [option.dataset.optionValueId]);
      if (variant && variant.id) productUrl.searchParams.set('variant', variant.id);

      updateCard(
        card,
        option,
        product,
        variant,
        productUrl.pathname + productUrl.search + productUrl.hash
      );
    } catch (error) {
      if (error.name !== 'AbortError') {
        window.console.error('[BDP Combined Listings] Product card update failed.', error);
      }
    } finally {
      if (cardRequests.get(card) === controller) {
        card.classList.remove('is-combined-listings-loading');
        card.removeAttribute('aria-busy');
        cardRequests.delete(card);
      }
    }
  }

  function renderSelectedCombinedListing(root) {
    root = root || document;
    var sections = root.matches && root.matches(selectors.productSection)
      ? [root]
      : Array.prototype.slice.call(root.querySelectorAll(selectors.productSection));

    sections.some(function (section) {
      var selected = section.querySelector(
        'select option:checked[data-combined-listing-value][data-product-url], ' +
        'input:checked[data-combined-listing-value][data-product-url], ' +
        'button.selected[data-combined-listing-value][data-product-url]'
      );

      if (!shouldSwitchProduct(selected)) return false;
      swapProductSection(selected);
      return true;
    });
  }

  document.addEventListener('click', function (event) {
    var cardOption = event.target instanceof Element
      ? event.target.closest(selectors.cardOption)
      : null;

    if (cardOption) {
      event.preventDefault();
      event.stopPropagation();
      selectCardOption(cardOption);
      return;
    }

    var productOption = optionFromEventTarget(event.target);
    if (!shouldSwitchProduct(productOption)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    swapProductSection(productOption);
  }, true);

  document.addEventListener('change', function (event) {
    var productOption = optionFromEventTarget(event.target);
    if (!shouldSwitchProduct(productOption)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    swapProductSection(productOption);
  }, true);

  window.addEventListener('load', function () {
    renderSelectedCombinedListing(document);
  });

  window.BDPCombinedListings = {
    refresh: function (root) {
      renderSelectedCombinedListing(root || document);
    }
  };
})();
